import React, {useState} from "react";
import { useForm } from "react-hook-form";
import { toast } from '../utils/toast';
import { useSubmitGuard } from '../utils/useSubmitGuard';
import { errorMessage } from '../utils/errorMessage';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { API_DETAILS } from "../App";

const PrivacyPolicy = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  
  const navigate = useNavigate();
  const [invalidState, setInvalidState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [registering, guard] = useSubmitGuard();

  const onSubmit = guard(() => {
    setLoading(true);
    let usrData = props.data;
    usrData['userType'] = props.uType;
    if(props.uType== 'PATIENT'){  
      usrData['subscriptionStatus'] = props.subscription;
      usrData['hasInsurance'] = usrData['hasInsurance'] == undefined ? false : (usrData['hasInsurance'] == 'no' ? false : true);
    }
    
    delete usrData.confirmPassword;
    const config = {
      headers: {          
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Content-Type': 'application/json'
      }
  };
    return axios.post(API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +"/auth/register", usrData, config).then((res) => {
      toast.success("Your account is created. Next, verify your email address.");
      navigate("/verify-email",  { state: { userEmail : usrData.email } });
    }).catch((err) => {
        // err.response is undefined when the request fails before the server
        // answers (backend down, DNS, offline). Reading .data on it threw, so
        // the error handler itself crashed the page instead of showing a toast.
        const message =
          errorMessage(err, "We couldn't create your account. Check your details and try again.");
        toast.error(message)
        setLoading(false);
    });
  });

  return (
    <form className="PatientAddress-container" onSubmit={handleSubmit((onSubmit))}>
     <h1> youro</h1>
     <div className="policy-container">
        <h2>Terms of Service, Privacy Policy and HIPAA Notice</h2>
        <p>I am at least 18+ years of age and i have read and accept:</p>
        <div className="sub-policy-container">
            <div className="color-secondary" style={{textDecoration: 'underline'}}><a href="/policy" target="_blank">Privacy Policy</a></div>
            <div style={{alignItems: 'flex-end', display: 'flex', flexDirection: "column"}}>
              <input type="checkbox" style={{width: 'fit-content'}} {...register("privacy", {
                                  required: true,
                                })} />
              {errors.privacy && <p className="error-text">This field is required</p>}
            </div>
        </div>
        <div className="sub-policy-container">
            <div className="color-secondary" style={{textDecoration: 'underline'}}><a href="/telehealth-consent" target="_blank">Telehealth consent</a></div>
            <div>
            <div style={{alignItems: 'flex-end', display: 'flex', flexDirection: "column"}}>
              <input type="checkbox" style={{width: 'fit-content'}} {...register("telehealth", {
                                  required: true,
                                })} />
              {errors.telehealth && <p className="error-text">This field is required</p>}
            </div>
            </div>
        </div>
        <div className="sub-policy-container">
            <div className="color-secondary" style={{textDecoration: 'underline'}}><a href="/terms-conditions" target="_blank">Terms & Conditions</a></div>
            <div>
            <div style={{alignItems: 'flex-end', display: 'flex', flexDirection: "column"}}>
              <input type="checkbox" style={{width: 'fit-content'}} {...register("terms", {
                                  required: true,
                                })} />
              {errors.terms && <p className="error-text">This field is required</p>}
            </div>
            </div>
        </div>
     </div>
     <div className="myself-label" style={{position: "relative", width: "35%", padding: "20px 0px 20px 20px", display: "flex", justifyContent: "flex-end"}}>
            <button type="submit" className="btn-filled" style={{width: 'fit-content'}} disabled={registering} aria-busy={registering}>Finish</button>    
        </div>
    </form>
  );
};

export default PrivacyPolicy;